import React from 'react';
import { Grid } from '@mui/material';
import { DateObject, TimeWindow } from '@uplift/services';

import { MonthPicker, MonthPickerProps } from './MonthPicker.component';


export type MonthRangePickerProps = Omit<MonthPickerProps, 'onChange' | 'label' | 'value'> & {
  labelFrom: string;
  labelTo: string;
  onChange: (range: TimeWindow) => void;
  value: TimeWindow;
};


export const MonthRangePicker: React.FC<MonthRangePickerProps> = ({ value: _value, labelFrom, labelTo, onChange, ...props }) => {
  const handleFromChange = (value: DateObject) => {
    const newRange: TimeWindow = {
      start: value,
      end: value.isAfter(_value.end) ? value : _value.end,
    };

    onChange(newRange);
  };

  const handleToChange = (value: DateObject) => {
    const newRange: TimeWindow = {
      start: value.isBefore(_value.start) ? value : _value.start,
      end: value,
    };

    onChange(newRange);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <MonthPicker label={labelFrom} {...props} value={_value?.start} onChange={handleFromChange} />
      </Grid>
      <Grid size={12}>
        <MonthPicker label={labelTo} {...props} value={_value?.end} onChange={handleToChange} />
      </Grid>
    </Grid>
  );
};
